export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1, maximum-scale=1.0"},{"charset":"utf-8"},{"hid":"description","name":"description","content":"Bunce is a payment automation tool that helps businesses grow their revenue and customers with integrations to all payment processors and accounting software in Africa."},{"hid":"keywords","name":"keywords","content":"Payment, Automation, revenue growth, customer growth, Paystack, Flutterwave, invoicing"},{"name":"format-detection","content":"telephone=no"},{"property":"og:title","content":"Supercharge your revenue and customer growth"},{"property":"og:description","content":"Bunce is a payment automation tool that helps businesses grow their revenue and customers with integrations to all payment processors and accounting software in Africa."},{"property":"og:type","content":"website"},{"property":"og:url","content":"https://app.bunce.so/"},{"property":"fb:app_id","content":"767001741918145"},{"property":"og:image","content":"https://app.bunce.so/thumbnail.png"},{"property":"og:image:width","content":"3800"},{"property":"og:image:height","content":"1900"},{"property":"og:site_name","content":"Bunce"},{"property":"twitter:site","content":"@trybunce"},{"property":"twitter:card","content":"summary_large_image"}],"link":[{"rel":"icon","type":"image/x-icon","href":"/favicon.png"}],"style":[],"script":[{"src":"https://unpkg.com/ionicons@7.1.0/dist/ionicons/ionicons.esm.js","type":"module"}],"noscript":[],"charset":"utf-8","viewport":"width=device-width, initial-scale=1, maximum-scale=1.0","bodyAttrs":{"class":"overflow-x-hidden"}}

export const appPageTransition = {}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appViewTransition = true

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appRootAttrs = {"id":"__nuxt"}

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const appTeleportAttrs = {"id":"teleports"}

export const appSpaLoaderTag = "div"

export const appSpaLoaderAttrs = {"id":"__nuxt-loader"}

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = false

export const cookieStore = true

export const appManifest = false

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"activeClass":"active","exactActiveClass":"active","componentName":"NuxtLink","prefetch":true,"prefetchOn":{"visibility":true}}

export const asyncDataDefaults = {"deep":true,"value":null,"errorValue":null}

export const resetAsyncDataToUndefined = true

export const nuxtDefaultErrorValue = null

export const fetchDefaults = {"retry":2,"retryDelay":100,"retryStatusCodes":[500,429],"timeout":500}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = true

export const appId = "nuxt-app"

export const outdatedBuildInterval = 3600000

export const multiApp = false

export const chunkErrorEvent = "vite:preloadError"

export const crawlLinks = true

export const spaLoadingTemplateOutside = false

export const purgeCachedData = true

export const granularCachedData = false

export const pendingWhenIdle = true

export const alwaysRunFetchOnKeyChange = true